import {
  AddedInstitutionsParams,
  AddedParticipantParams,
  DakeEnumOptionsResult,
  DakeGetAllRegionTreeResp,
  DakeListChannelsExportReq,
  DeleteParticipantParams,
  EditInstitutionsParams,
  GetBindWxShopListParams,
  GetBindWxShopListResult,
  GetListParticipantsParams,
  GetListParticipantsResult,
  GetParticipantParams,
  GetParticipantResult,
  InstitutionsSettleInDetailParams,
  InstitutionsSettleListParams,
  InstitutionsSettleListResult,
  UpdateParticipantParams,
  UpdateStoreProductVisibilityParams,
  UploadHeadImgResult,
} from "@/data-contracts";
import request, { _POST } from "@/services/request";

/**
 * 获取角色列表(机构或者选品)
 * */
const getInstitutionsSettleList = (params: InstitutionsSettleListParams) => {
  return request<InstitutionsSettleListResult, InstitutionsSettleListParams>(_POST, "/admin/ListChannels")(params);
};

/**
 * 获取单个角色的详细信息
 * */
const getInstitutionsSettleInDetail = (params: InstitutionsSettleInDetailParams) =>
  request<null, InstitutionsSettleInDetailParams>(_POST, "/admin/GetChannel")(params);

/**
 * 新增角色
 * */
const addedInstitutions = (params: AddedInstitutionsParams) =>
  request<null, AddedInstitutionsParams>(_POST, "/admin/AddChannel")(params);

/**
 * 编辑角色
 * */
const editInstitutions = (params: EditInstitutionsParams) =>
  request<null, EditInstitutionsParams>(_POST, "/admin/UpdateChannel")(params);

/**
 * 编辑角色
 * */
const updateSelectionServiceFeePermission = (params: EditInstitutionsParams) =>
  request<null, EditInstitutionsParams>(_POST, "/admin/channel/updateSelectionServiceFeePermission")(params);

/**
 * 获取账号列表
 * */
const getListParticipants = (params: GetListParticipantsParams) =>
  request<GetListParticipantsResult, GetListParticipantsParams>(_POST, "/admin/ListParticipants")(params);

/**
 * 获取账号详情
 * */
const getParticipant = (params: GetParticipantParams) =>
  request<GetParticipantResult, GetParticipantParams>(_POST, "/admin/GetParticipant")(params);

/**
 * 新增账号
 * */
const addedParticipant = (params: AddedParticipantParams) =>
  request<null, AddedParticipantParams>(_POST, "/admin/AddParticipant")(params);

/**
 * 绑定微信小店
 * */
const bindWxShop = (params: { wxShopId: string; channelId: string }) =>
  request<{ shopName: string }, { wxShopId: string; channelId: string }>(_POST, "/admin/BindWxShop")(params);

/**
 * 删除账号
 * */
const deleteParticipant = (params: DeleteParticipantParams) =>
  request<null, DeleteParticipantParams>(_POST, "/admin/DelParticipant")(params);

/**
 * 更新账号
 * */
const updateParticipant = (params: UpdateParticipantParams) =>
  request<null, UpdateParticipantParams>(_POST, "/admin/UpdateParticipant")(params);
/**
 * 绑定小店管理
 * */
const getBindWxShopList = (params: GetBindWxShopListParams) =>
  request<GetBindWxShopListResult, GetBindWxShopListParams>(_POST, "/admin/ListBindedShops")(params);

/**
 * 获取全部枚举选项；当前包含 productVisibility、sampleGmv、sampleFans
 * */
const getEnumOptions = (params: Record<string, never> = {}) =>
  request<DakeEnumOptionsResult, Record<string, never>>(_POST, "/admin/enum/options")(params);

/**
 * 更新店铺商品可见范围
 * */
const updateStoreProductVisibility = (params: UpdateStoreProductVisibilityParams) =>
  request<null, UpdateStoreProductVisibilityParams>(
    _POST,
    "/admin/store/updateProductVisibility"
  )(params);

/**
 * 上传
 * */
const UploadHeadImg = (params: FormData) => request<UploadHeadImgResult, FormData>(_POST, "/admin/UploadImage")(params);

// 登出
export const LOGOUT = () => request<null, null>(_POST, "/dake-biz/v1/auth/logout")(null);

interface UploadHeadCOSImgParams {
  application: string;
  key: string;
}

/**
 * 上传
 * */
const UploadHeadCOSImg = (params: UploadHeadCOSImgParams) =>
  request<{ presignUploadUrl: string }, UploadHeadCOSImgParams>(_POST, "/admin/cos/presign_upload_url")(params);

/**
 * DakeAdmin_ChannelsExport
 *
 * /admin/ChannelsExport
 *
 * params: DakeListChannelsExportReq
 * */
const dakeListChannels = (params?: DakeListChannelsExportReq) =>
  request<null, DakeListChannelsExportReq>(_POST, "/admin/ChannelsExport")(params ?? {});

const appApis = {
  UploadHeadCOSImg,
  getInstitutionsSettleList,
  getInstitutionsSettleInDetail,
  addedInstitutions,
  editInstitutions,
  getListParticipants,
  getParticipant,
  getBindWxShopList,
  getEnumOptions,
  updateStoreProductVisibility,
  UploadHeadImg,
  updateParticipant,
  deleteParticipant,
  addedParticipant,
  bindWxShop,
  dakeListChannels,
  updateSelectionServiceFeePermission,
};

export default appApis;
